var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.boxClass,style:(_vm.customStyles)},[_c('div',{class:_vm.titleClass},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{class:_vm.messageClass},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }